import { BehaviorSubject, Observable, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { NgIf } from '@angular/common';
import { ViewportRuler } from '@angular/cdk/overlay';

import { SideNavFooterComponent } from '../side-nav-footer';
import { BreadcrumbsComponent } from '../../breadcrumbs';

import { SlotComponent } from '@iss/core/utils';

@Component({
  selector: 'iss-side-nav-container',
  templateUrl: './side-nav-container.component.html',
  styleUrls: [ './side-nav-container.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    BreadcrumbsComponent,
    SideNavFooterComponent,
    SlotComponent,
  ],
})
export class SideNavContainerComponent implements AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly heightSubject = new BehaviorSubject(0);
  public readonly height$: Observable<number> = this.heightSubject.asObservable();
  @ViewChild('ref') public ref?: ElementRef<HTMLElement>;

  public constructor(private readonly viewportRuler: ViewportRuler) {}

  public ngAfterViewInit(): void {
    this.heightSubject.next(this.getHeight());

    this.viewportRuler.change(500).pipe(
      tap(() => {
        const height = this.getHeight();
        if (height !== this.heightSubject.value) {
          this.heightSubject.next(height);
        }
      }),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe();
  }

  private getHeight(): number {
    return this.ref?.nativeElement.offsetHeight || 0;
  }
}
